(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3StatsDashboard', {
            templateUrl: 'app/club-admin/stats-dashboard/stats-dashboard.component.html',
            controller: StatsDashboardComponent,
            bindings: { dashboard: '<' }
        });

    var extend = angular.extend;

    StatsDashboardComponent.$inject = ['barChartDefaultOptions', 'scoresPostedChartDefaults', 'uniqueGolfersChartDefaults'];
    function StatsDashboardComponent(barChartDefaultOptions, scoresPostedChartDefaults, uniqueGolfersChartDefaults) {
        var ctrl = this,
            chartColumns = ['thisWeek', 'lastWeek', 'thisSeason'];

        ctrl.chartOptions = barChartDefaultOptions;
        ctrl.$onInit = init;

        function init() {
            ctrl.scoresPostedChart = createChart(ctrl.dashboard.scorePostStats, true);
            ctrl.uniqueGolfersChart = createChart(ctrl.dashboard.golferPostStats, false);
        }

        function createChart(data, isScoresPosted) {
            var defaults = isScoresPosted ? scoresPostedChartDefaults : uniqueGolfersChartDefaults;
            return extend({ data: data.map(map) }, defaults);

            function map(item) {
                return chartColumns.map(function (x) { return item[x]; });
            }
        }
    }
})();